<a
  [routerLink]="'/home'"
  class="flex items-center rtl:space-x-reverse"
>
  <logo-icon />
</a>
